module.exports = __webpack_public_path__ + "img/92.dc069900.jpg";